import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { combineLatest, filter } from 'rxjs';
import { GetDocumentDto } from 'src/app/modules/documents/models/documents.model';
import {
  selectSendingReport,
  selectSendingReportDocument,
} from 'src/app/modules/documents/store/selectors';
import { AppState } from '../../../store/state';
import { isPresent } from '../../../utils/isPresent';

@UntilDestroy()
@Component({
  selector: 'app-report-notification',
  templateUrl: './report-notification.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportNotificationComponent implements OnInit {
  public creatingReport: boolean = false;
  public document: GetDocumentDto | null = null;

  constructor(
    private store$: Store<AppState>,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    combineLatest([
      this.store$.select(selectSendingReport).pipe(filter(isPresent)),
      this.store$.select(selectSendingReportDocument).pipe(filter(isPresent)),
    ])
      .pipe(untilDestroyed(this))
      .subscribe(([sendingReport, document]) => {
        this.creatingReport = sendingReport;
        this.document = document;

        this.cdr.markForCheck();
      });
  }

  get docName(): string | undefined {
    return this.document?.name;
  }
}
